import React from 'react'
import styles from './PrimaryButton.module.css'
import PropTypes from 'prop-types'

const PrimaryButton = ({
  children,
  onClick,
  disabled = false,
}) => {
  const handleClick = event => {
    event.preventDefault()
    event.stopPropagation()

    onClick(event)
  }

  return (
    <button type="button" className={ styles.button } onClick={ handleClick } disabled={ disabled }>
      { children }
    </button>
  )
}

PrimaryButton.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
}

export default PrimaryButton
